let openLoginModalFn: (() => void) | null = null;
let logoutFn: (() => void) | null = null;

export const AuthBridge = {
  registerOpenLoginModal(fn: () => void) {
    openLoginModalFn = fn;
  },
  openLoginModal() {
    if (openLoginModalFn) openLoginModalFn();
  },
  registerLogout(fn: () => void) {
    logoutFn = fn;
  },
  logout() {
    if (logoutFn) logoutFn();
  },
};
